const PREFIX = 'sections';
export const GET_SECTION_ENROLLMENT = PREFIX + ':get:enrollment';
export const SET_ENROLLMENT_ALERT = PREFIX + ':set:enrollment:alert';
export const STORE_ENROLLMENT = PREFIX + ':store:enrollment';
export const SET_SECTION_ENROLLMENT = PREFIX + ':set:enrollment';

export const  getSectionEnrollment = (id, token) => {
    return{
        type: GET_SECTION_ENROLLMENT,
        id, 
        token
    }
}

export const  storeEnrollment = (item) => {
    return{
        type: STORE_ENROLLMENT,
        item, 
    }
}


export function setEnrollmentAlert(value = false) {
    return {
        type: SET_ENROLLMENT_ALERT,
        result: value 
    }
}

export const  setSectionEnrollment = (sectionObj, userId, roleId, token) => {

    const data = {
        "enrollment[user_id]": userId,
        "enrollment[role_id]": roleId,
        "enrollment[enrollment_state]": "active"
    }
    return{
        type: SET_SECTION_ENROLLMENT,
        id: sectionObj.id, 
        data,
        courseId: sectionObj.course_id,
        token
    }
}